import {inject, Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot} from '@angular/router';
import {MasterDataService} from '../master-data/master-data-service';
import {Observable} from 'rxjs';
import {OrderType} from '../master-data/master-data.model';

@Injectable({providedIn: 'root'})
export class TypesResolve   {
  private masterDataService = inject(MasterDataService);


  getTypes(): Observable<OrderType[]> {
    return this.masterDataService.getTypes();
  }
}

export const typesResolver: ResolveFn<OrderType[]> =
  (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  console.log('TYPES RESOLVER');
    return inject(TypesResolve).getTypes();
  };

